import React from "react";
import { Route, Redirect } from "react-router-dom";
import ForgotPassword from "./components/forgotPassword";
import ConfirmForgotPassword from "./components/confirmForgotPassword";
import CurrentUser from "./components/Users/current-user";
import importExport from "./components/Import-Export";
import SiteMetrics from "./components/Dashboard/Site Metrics";
import AWSMetrics from "./components/Dashboard/AWS";
import importExportPriceData from "./components/Import-Export-Price-Data";
import StudioWrapper from "./components/Shared/StudioWrapper";
import PreciousPricing from "./components/Precious-Pricing-Calculator";
import Screensaver from "./components/Screensaver";
import RingFinish from "./components/NetsuiteIDs/RingFinish";
import InlayFinish from "./components/NetsuiteIDs/InlayFinish";
import PreciousPricingCalculator from "./components/Precious-Pricing-Calculator";

export default [
  <Route exact path="/forgot-password" component={ForgotPassword} noLayout />,
  <Route
    exact
    path="/confirm-password"
    component={ConfirmForgotPassword}
    noLayout
  />,
  <Route path="/profile" component={CurrentUser} exact />,
  <Route path="/bulk-products" component={importExport} exact />,
  <Route path="/sort-order" exact render={() => <Redirect to="/ring-material-sort-order" />} />,
  <Route path="/netsuite/ring-finish" component={RingFinish} exact />,
  <Route path="/netsuite/inlay-finish" component={InlayFinish} exact />,
  <Route path="/precious-pricing-calculator" component={PreciousPricingCalculator} exact />,
  <Route path="/screensaver" component={Screensaver} exact />,
  <Route
    path="/export-product-price"
    component={importExportPriceData}
    exact
  />,
  <Route path="/dashboard/site" component={SiteMetrics} exact />,
  <Route path="/dashboard/application" component={AWSMetrics} exact />,
  <Route
    path={["/signet-studio", "/design-pattern-studio"]}
    component={StudioWrapper}
  />,
];
